(() => {
  // Staff opt-in is established before Shopify loads analytics integrations.
  if (window.muzeStaffQA === true) return;
  const projectId = document.currentScript?.dataset.projectId;
  const privatePath = /\/(?:account|cart|checkout|checkouts|challenge|authentication)(?:\/|$)/i;
  if (!projectId || privatePath.test(location.pathname)) return;

  // Do not initialize session capture on links carrying private form/auth data.
  const privateQuery = /^(?:email|phone|address|password|token|access_token|key|customer_id)$/i;
  if ([...new URLSearchParams(location.search).keys()].some((key) => privateQuery.test(key))) return;

  window.clarity = window.clarity || function () {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };
  const consent = (analyticsAllowed) => window.clarity('consentv2', {
    ad_Storage: 'denied',
    analytics_Storage: analyticsAllowed ? 'granted' : 'denied',
  });
  consent(false);

  let scheduled = false;
  let started = false;
  const analyticsAllowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const start = () => {
    scheduled = false;
    if (started || !analyticsAllowed()) return;
    consent(true);
    const tag = document.createElement('script');
    tag.id = 'muze-clarity-tag';
    tag.async = true;
    tag.fetchPriority = 'low';
    tag.src = `https://www.clarity.ms/tag/${projectId}`;
    document.head.appendChild(tag);
    started = true;
  };
  const updateConsent = () => {
    const allowed = analyticsAllowed();
    consent(allowed);
    if (!allowed || started || scheduled) return;
    scheduled = true;
    // Keep session analytics out of the initial parsing/rendering work.
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(start, { timeout: 1500 });
    } else {
      window.setTimeout(start, 0);
    }
  };

  document.addEventListener('visitorConsentCollected', updateConsent);
  if (window.Shopify?.customerPrivacy) {
    updateConsent();
  } else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) updateConsent();
    });
  }
})();
